import {signInWithPopup, UserCredential, User} from "firebase/auth";
import {auth, provider} from "./firebaseInit";

export async function getToken(): Promise<string> {
    const logRes: UserCredential = await signInWithPopup(auth, provider);
    const user: User = logRes.user;
    return await user.getIdToken();
}